<svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <polygon fill-rule="evenodd" points="9.49128971 3.44889761 10.5087103 4.55110239 5.66271051 9.02433639 2.48704449 6.04715322 3.51295551 4.95284678 5.67 6.975"/>
</svg>